import { AppointmentControllerApi, RescheduleAppointment } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author Rajkumar Rathod
 */
export const useRescheduleAppointment = () =>
  useMutationWithLoading(
    async (params: {
      rescheduleAppointment: RescheduleAppointment;
      xTENANTID?: string;
    }) =>
      new AppointmentControllerApi(getConfigObject()).reschduleAppointment(
        params.rescheduleAppointment,
        params?.xTENANTID
      )
  );

